export default __webpack_public_path__ + "static/media/ic-geo-fence.16711cb3.svg";